import { request } from './request';

export const fetchClientConfig = async (): Promise<Record<
  string,
  unknown
> | null> => {
  try {
    const response = await request('/system/clientconfig', {
      requireAuth: true,
      retries: 3,
    });
    const ok = response.status >= 200 && response.status < 300;
    return ok ? response.data : null;
  } catch {
    return null;
  }
};
